"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, Vue, Emit, PropSync } from "vue-property-decorator";
let UploadEnclosureBottom = class extends Vue {
  openUploadEmit() {
    return;
  }
  saveEmit() {
    return;
  }
  downloadAllEmit() {
    return;
  }
  removeAllEmit() {
    return;
  }
  openUpload() {
    this.openUploadEmit();
  }
  downloadAll() {
    this.downloadAllEmit();
  }
  removeAll() {
    this.removeAllEmit();
  }
  save() {
    this.saveEmit();
  }
};
__decorateClass([
  PropSync("showSaveValue", {
    type: Boolean,
    default: function() {
      return false;
    }
  })
], UploadEnclosureBottom.prototype, "showSave", 2);
__decorateClass([
  Emit()
], UploadEnclosureBottom.prototype, "openUploadEmit", 1);
__decorateClass([
  Emit()
], UploadEnclosureBottom.prototype, "saveEmit", 1);
__decorateClass([
  Emit()
], UploadEnclosureBottom.prototype, "downloadAllEmit", 1);
__decorateClass([
  Emit()
], UploadEnclosureBottom.prototype, "removeAllEmit", 1);
UploadEnclosureBottom = __decorateClass([
  Component({})
], UploadEnclosureBottom);
export {
  UploadEnclosureBottom as default
};
